<template lang="pug">
    v-container
        v-layout.pa-2(wrap)
            v-flex(md6)
                v-icon person
                | Cajero:
            //- v-flex.informationSummaries(md6) {{initialSummaries.opening_user}}
            v-flex.informationSummaries(md6) {{user.hr_employee.name_case}}

            v-flex(md6)
                v-icon watch_later
                | Fecha y hora de cierre (no exacta):
            v-flex.informationSummaries(md6) {{date}} {{time}}
        v-layout(row wrap)
            v-flex(xs12 md6 pa-2)
                v-text-field(prefix="$" validate-on-blur v-model="cash"
                    label="Monto de cierre"
                    :mask="mixCurrencyMask(cash, 12)"
                    :rules="[rules.required, rules.rounded]"
                    @input="setCashAmount(cash)")
            v-flex(xs12 md6 pa-2)
                h3 Comentario
                v-textarea(solo label="Escriba aquí" v-model="comment" auto-grow outline
                    @input="setComment(comment)")
</template>

<script>
import DateStrings from '@/mixins/DateStrings.js'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import {mapActions, mapState} from 'vuex'
export default {
    name: 'information-close',
    props: {},
    data: function(){
        return {
            date: DateStrings.getDate(),
            time: DateStrings.getTime(),
            cash: '',
            comment:'',
        }
    },
    computed: {
        // ...mapState('PaymentSummariesModule',{
        //     openingUser:'openingUser',
        //     openingTimeStamp :'openingTimeStamp',
        //     initialAmountCash :'initialAmountCash'
        // })
        ...mapState('CloseCashModule', {
            initialSummaries: 'initialSummaries'
        }),
        ...mapState('AuthModule', {
            user: 'user'
        }),
        rules: function() {
            return {
                required: value =>
                    !!value || 'Este campo no puede estar vacío.',
                rounded: value => (parseInt(value) % 10) === 0 || 'Debe ingresar un valor multiplo de 10',
            }
        },
    },
    methods: {

        clearForm(){
            cash= ''
            comment=''
        },

        ...mapActions('CloseCashModule', {
            setComment: 'setComment',
            setCashAmount: 'setCashAmount',
        }),
        
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){},
    // beforeMount: function(){...},
    mounted: function(){
        this.$emit('clearFormHandler', this.clearForm )
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>